import React from 'react';
import styled from 'styled-components';

import { rhythm } from '../utils/typography';
import { from, Breakpoints } from '../utils/theme';

const Section = styled.section`
  margin-bottom: ${rhythm(1)};
  ${from(Breakpoints.MD, ` margin-bottom: ${rhythm(2)};`)}
`;

const Javascript = styled.span`
  background-color: #edd53f;
  color: black;
  padding: 0 ${rhythm(0.5)};
  border-radius: 5px;
`;

const Typescript = styled.span`
  background-color: #187abf;
  color: white;
  padding: 0 ${rhythm(0.5)};
  border-radius: 5px;
`;

const Title = styled.h1`
  line-height: ${rhythm(2.2)};
  margin-top: 0;
`;

const Hero: React.FC = () => (
  <Section>
    <Title>
      Doodles about <Javascript>Software</Javascript>{' '}
      <Typescript>Engineering</Typescript> and more.
    </Title>
  </Section>
);

export default Hero;
